function encode_varint(n, a=[]) {
  a.push((n<0x80 ? 0 : 0x80) | (n & 0x7f));
  for(; ( n>>>=7 ) > 0 ;)
    a.push((n<0x80 ? 0 : 0x80) | (n & 0x7f));
  return a
}

function decode_varint(u8, i0=0, invalid) {
  let shift=0, i=i0, b=u8[i++], n=(b & 0x7f);
  for(; b & 0x80;)
    n |= ((b=u8[i++]) & 0x7f) << (shift += 7);

  return (u8.length < i)
    ? [invalid, i0, i0] // fail: insuffecient u8 bytes to decode
    : [n, i, i0] // successful value
}

class mqtt_reason extends Number {
  constructor(v, reason) {
    super(v);
    this.reason = `:${(this.ok = v<0x80) ? 'ok' : 'fail'}:${reason}`;
  }
}

let mqtt_reader_v4$1 = class mqtt_reader_v4 {
  static for(pkt, u8_body) { return new this().of(u8_body, {pkt}) }
  of(buf, opt) {
    let step = (width, k) => (k=0|step.k, step.k=k+width, k);
    return {__proto__: this, buf, step, ...opt}
  }

  has_more() {
    return this.buf.byteLength > (this.step.k|0)
  }

  u8() {
    return this.buf[this.step(1)]
  }

  u16() {
    let {buf, step} = this, i = step(2);
    return (buf[i]<<8) | buf[i+1]
  }

  u32() {
    let {buf, step} = this, i = step(4);
    return (buf[i]<<24) | (buf[i+1]<<16) | (buf[i+2]<<8) | buf[i+3]
  }

  vint() {
    let {buf, step} = this;
    let [n, vi, vi0] = decode_varint(buf, step.k|0);
    step(vi - vi0);
    return n
  }

  bin() {
    let {buf, step} = this, i = step(2);
    let len = (buf[i]<<8) | buf[i+1];
    i = step(len);
    return buf.subarray(i, i+len)
  }

  utf8() { return new TextDecoder('utf-8').decode(this.bin()) }
  pair() { return [ this.utf8(), this.utf8() ] }

  flags(FlagsType) { return new FlagsType(this.buf[this.step(1)]) }

  reason(pkt_kind) {
    let v = this.buf[this.step(1)];
    if (null != v)
      return new mqtt_reason(v, this._reason_for?.(v, pkt_kind))
  }

  flush() {
    let {buf, step} = this;
    this.step = this.buf = null;
    return buf.subarray(step.k|0)
  }

};

function with_reasons(mqtt_reader, by_kind) {
  for (let [k,lut] of Object.entries(by_kind))
    by_kind[k] = new Map(lut);

  return class extends mqtt_reader {
    _reason_for(v, pkt_kind) {
      return by_kind[pkt_kind]?.get(v) || by_kind.all.get(v)
    }
    warn(msg) {
      let pkt = this.pkt;
      pkt.warn ? pkt.warn(msg, pkt)
        : console.warn('[u8-mqtt-packet] '+msg);
    }
  }
}


const reasons_v4 =  {
  connack: [
    [ 0x01, 'conn refused: unacceptable protocol version'],
    [ 0x02, 'conn refused: identifier rejected'],
    [ 0x03, 'conn refused: server unavailable'],
    [ 0x04, 'conn refused: bad user name or password'],
    [ 0x05, 'conn refused: not authorized'],
  ],
  suback: [
    [ 0x00, 'qos=0'],
    [ 0x01, 'qos=1'],
    [ 0x02, 'qos=2'],
  ],
  unsuback: [
    [ 0x11, 'no subscription existed'],
  ],
  puback: [
    [ 0x10, 'no matching subscribers'],
  ],
  all: [
    [ 0, ''], // Success
    [ 0x80, 'unspecified error'], // disconnect puback suback unsuback
    [ 0x83, 'implementation specific error'], // connack disconnect puback suback unsuback
    [ 0x87, 'not authorized'], // connack disconnect puback suback unsuback
    [ 0x8F, 'topic filter invalid'], // disconnect suback unsuback
    [ 0x91, 'packet identifier in use'], // puback suback unsuback
    [ 0x92, 'packet identifier not found' ], // pubxxx
  ]};

const mqtt_reader_v4 = /* #__PURE__ */
  with_reasons(mqtt_reader_v4$1, reasons_v4);

class mqtt_writer_v4 {
  static for(pkt) { return new this().of() }
  of() { return {__proto__: this, $:[]} }

  static init() { return this }

  as_pkt(pkt_id) { return this.pack([pkt_id]) }

  push(...z) { this.$.push(...z); }
  pack(hdr) {
    let z, i, n=0, parts = this.$;
    this.$ = false;
    for (z of parts) n += z.length;

    hdr = encode_varint(n, hdr);
    i = hdr.length;

    let pkt = new Uint8Array(i + n);
    pkt.set(hdr, 0);
    for (z of parts) {
      pkt.set(z, i);
      i += z.length;
    }
    return pkt
  }

  u8(v) { this.push([ v & 0xff ]); }
  u16(v) { this.push([ (v>>>8) & 0xff, v & 0xff ]); }
  u32(v) { this.push([ (v>>>24) & 0xff, (v>>>16) & 0xff, (v>>>8) & 0xff, v & 0xff ]); }
  vint(v) { this.push( encode_varint(v) );}

  bin(u8_buf) {
    if (! u8_buf) return this.u16(0)
    if ('string' === typeof u8_buf)
      return this.utf8(u8_buf)

    if (u8_buf.length !== u8_buf.byteLength)
      u8_buf = new Uint8Array(u8_buf);

    this.u16(u8_buf.byteLength);
    this.push(u8_buf);
  }

  utf8(v) {
    let u8_buf = new TextEncoder('utf-8').encode(v);
    this.u16(u8_buf.byteLength);
    this.push(u8_buf);
  }
  pair(k,v) { this.utf8(k); this.utf8(v); }

  flags(v, enc_flags, b0=0) {
    if (undefined !== v && isNaN(+v))
      v = enc_flags(v, 0);

    v |= b0;
    this.push([v]);
    return v
  }

  reason(v) { this.push([v | 0]); }

  flush(buf) {
    if (null != buf)
      this.push(
        'string' === typeof buf
          ? new TextEncoder('utf-8').encode(buf)
          : buf );

    this.push = false;
  }
}

function mqtt_encode_connect(ns, mqtt_writer) {
  const _c_mqtt_proto = new Uint8Array([
    0, 4, 0x4d, 0x51, 0x54, 0x54 ]);

  const _enc_flags_connect = flags => 0
      | ( flags.reserved ? 0x01 : 0 )
      | ( (flags.will_qos & 0x3) << 3 )
      | ( flags.clean_start ? 0x02 : 0 )
      | ( flags.will_flag ? 0x04 : 0 )
      | ( flags.will_retain ? 0x20 : 0 )
      | ( flags.password ? 0x40 : 0 )
      | ( flags.username ? 0x80 : 0 );

  const _enc_flags_will = will => 0x4
      | ( (will.qos & 0x3) << 3 )
      | ( will.retain ? 0x20 : 0 );

  return ns.connect = ( mqtt_level, pkt ) => {
    let wrt = mqtt_writer.for(pkt);

    wrt.push(_c_mqtt_proto);
    wrt.u8( mqtt_level );

    let {will, username, password} = pkt;
    let flags = wrt.flags(
      pkt.flags,
      _enc_flags_connect,
      0 | (username ? 0x80 : 0)
        | (password ? 0x40 : 0)
        | (will ? _enc_flags_will(will) : 0) );

    wrt.u16(pkt.keep_alive);

    if (5 <= mqtt_level)
      wrt.props(pkt.props);


    wrt.utf8(pkt.client_id);
    if (flags & 0x04) { // .will_flag
      if (5 <= mqtt_level)
        wrt.props(will.props);

      wrt.utf8(will.topic);
      wrt.bin(will.payload);
    }

    if (flags & 0x80) // .username
      wrt.utf8(username);

    if (flags & 0x40) // .password
      wrt.bin(password);

    return wrt.as_pkt(0x10)
  }
}

function mqtt_decode_connack(ns, mqtt_reader) {
  class _connack_flags_ extends Number {
    get session_present() { return this & 0x01 !== 0 }
  }

  return ns[0x2] = (pkt, u8_body) => {
    let rdr = mqtt_reader.for(pkt, u8_body);

    pkt.flags =
      rdr.flags(_connack_flags_);

    pkt.reason = rdr.reason(pkt.type);
    if (5 <= pkt.mqtt_level)
      pkt.props = rdr.props();
    return pkt }
}

function mqtt_encode_publish(ns, mqtt_writer) {
  return ns.publish = ( mqtt_level, pkt ) => {
    let qos = (pkt.qos & 0x3) << 1;
    let wrt = mqtt_writer.for(pkt);

    wrt.utf8(pkt.topic);
    if (0 !== qos)
      wrt.u16(pkt.pkt_id);

    if ( 5 <= mqtt_level) {
      wrt.props(pkt.props);
      wrt.flush(pkt.payload);
    } else {
      wrt.flush(pkt.payload);
    }

    return wrt.as_pkt(
      0x30 | qos | (pkt.dup ? 0x8 : 0) | (pkt.retain ? 0x1 : 0) )
  }
}

function mqtt_decode_publish(ns, mqtt_reader) {
  return ns[0x3] = (pkt, u8_body) => {
    let {hdr} = pkt;
    pkt.dup = Boolean(hdr & 0x8);
    pkt.retain = Boolean(hdr & 0x1);
    let qos = pkt.qos = (hdr>>1) & 0x3;

    let rdr = mqtt_reader.for(pkt, u8_body);
    pkt.topic = rdr.utf8();
    if (0 !== qos)
      pkt.pkt_id = rdr.u16();

    if (5 <= pkt.mqtt_level)
      pkt.props = rdr.props();

    pkt.payload = rdr.flush();
    return pkt }
}

function mqtt_encode_puback(ns, mqtt_writer) {
  return ns.puback = ( mqtt_level, pkt ) => {
    let wrt = mqtt_writer.for(pkt);

    wrt.u16(pkt.pkt_id);
    if (5 <= mqtt_level) {
      wrt.reason(pkt.reason);
      wrt.props(pkt.props);
    }

    return wrt.as_pkt(0x40)
  }
}


function mqtt_decode_puback(ns, mqtt_reader) {
  return ns[0x4] = (pkt, u8_body) => {
    let rdr = mqtt_reader.for(pkt, u8_body);

    pkt.pkt_id = rdr.u16();
    if (5 <= pkt.mqtt_level) {
      pkt.reason = rdr.reason(pkt.type);
      pkt.props = rdr.props();
    }

    return pkt }
}

function mqtt_encode_subscribe(ns, mqtt_writer) {
  const _enc_subscribe_flags = opts => 0
      | ( opts.qos & 0x3 )
      | ( opts.retain ? 0x4 : 0 )
      | ( (opts.retain_handling & 0x3) << 2 );

  return ns.subscribe = ( mqtt_level, pkt ) => {
    let wrt = mqtt_writer.for(pkt);

    wrt.u16(pkt.pkt_id);
    if (5 <= mqtt_level)
      wrt.props(pkt.props);

    let f0 = _enc_subscribe_flags(pkt);
    for (let each of pkt.topics) {
      if ('string' === typeof each) {
        wrt.utf8(each);
        wrt.u8(f0);
      } else {
        let [topic, opts] =
          Array.isArray(each) ? each
            : [each.topic, each.opts];

        wrt.utf8(topic);
        if (undefined === opts) wrt.u8(f0);
        else wrt.flags(opts, _enc_subscribe_flags);
      }
    }

    return wrt.as_pkt(0x82)
  }
}

function mqtt_decode_xxsuback(ns, mqtt_reader) {
  return ns[0x9] = ns[0xb] = (pkt, u8_body) => {
    let rdr = mqtt_reader.for(pkt, u8_body);

    pkt.pkt_id = rdr.u16();
    if (5 <= pkt.mqtt_level)
      pkt.props = rdr.props();

    let answers = pkt.answers = [];
    while (rdr.has_more())
      answers.push(
        rdr.reason(pkt.type) );

    return pkt }
}

function mqtt_encode_unsubscribe(ns, mqtt_writer) {
  return ns.unsubscribe = ( mqtt_level, pkt ) => {
    let wrt = mqtt_writer.for(pkt);

    wrt.u16(pkt.pkt_id);
    if (5 <= mqtt_level)
      wrt.props(pkt.props);

    for (let topic of pkt.topics)
      wrt.utf8(topic);

    return wrt.as_pkt(0xa2)
  }
}

function mqtt_encode_pingxxx(ns) {
  ns.pingreq  = () => new Uint8Array([ 0xc0, 0 ]);
  ns.pingresp = () => new Uint8Array([ 0xd0, 0 ]);
}


function mqtt_decode_pingxxx(ns) {
  return ns[0xc] = ns[0xd] = pkt => pkt
}

function mqtt_encode_disconnect(ns, mqtt_writer) {
  return ns.disconnect = ( mqtt_level, pkt ) => {
    let wrt = mqtt_writer.for(pkt);

    if (pkt && 5 <= mqtt_level) {
      if (pkt.reason || pkt.props) {
        wrt.reason(pkt.reason);
        wrt.props(pkt.props);
      }
    }

    return wrt.as_pkt(0xe0)
  }
}


function mqtt_decode_disconnect(ns, mqtt_reader) {
  return ns[0xe] = (pkt, u8_body) => {
    if (u8_body && 5 <= pkt.mqtt_level) {
      let rdr = mqtt_reader.for(pkt, u8_body);
      pkt.reason = rdr.reason(pkt.type);
      pkt.props = rdr.props();
    }
    return pkt }
}

const version = '0.4.1';

// not a v4 packet: import { mqtt_encode_auth, mqtt_decode_auth } from './pkt/auth.js'


const mqtt_decode_v4 =  [
  mqtt_decode_connack,
  mqtt_decode_publish,
  mqtt_decode_puback,
  mqtt_decode_xxsuback,
  mqtt_decode_pingxxx,
  mqtt_decode_disconnect,
];


const mqtt_encode_v4 =  [
  mqtt_encode_connect,
  mqtt_encode_puback,
  mqtt_encode_publish,
  mqtt_encode_subscribe,
  mqtt_encode_unsubscribe,
  mqtt_encode_pingxxx,
  mqtt_encode_disconnect,
];


const mqtt_opts_v4 = 
  { decode_fns: mqtt_decode_v4,
    mqtt_reader: mqtt_reader_v4,
    encode_fns: mqtt_encode_v4,
    mqtt_writer: mqtt_writer_v4, };

export { mqtt_opts_v4 as default, mqtt_decode_v4, mqtt_encode_v4, mqtt_opts_v4, mqtt_reader_v4, mqtt_writer_v4, version };
//# sourceMappingURL=codec_v4_client.js.map
